import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import ContactDetailsBox from "../contact-details-box/ContactDetailsBox";
import styles from "./contact-us-rebound-solution.module.scss";

function ContactUsReboundSolution({ solution: { id, fields, hierarchyPosition }, className }) {
  const locationOnPage = hierarchyPosition.join(" | ");

  return (
    <article className={classnames(styles.standardSolution, className)} data-solution-id={id}>
      <h2 className={styles.standardSolution__top}>Question on Rebound</h2>
      <div className={styles.standardSolution__inner} data-test="solution-inner">
        <ContactDetailsBox
          fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
          // buttonType={buttonType}
          solutionId={id}
          className={styles["standardSolution__contact-details"]}
          location={locationOnPage}
        />
      </div>
    </article>
  );
}

ContactUsReboundSolution.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string.isRequired,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
};

ContactUsReboundSolution.defaultProps = {
  className: undefined,
};

export default ContactUsReboundSolution;
